import type { Album } from "@/types/types";
import { MediaCard } from "./MediaCard";

export function AlbumCard({ album }: { album: Album }) {
  return (
    <MediaCard
      to={`/album/${album.id}`}
      coverId={album.cover_id}
      title={album.title}
      subtitle={album.artist.name + (album.year ? ` · ${album.year}` : "")}
    />
  );
}
